/* src/app/admin-dashboard/site-system/inventory/stockcontroll/stockcontroll.component.css */
mat-grid-tile {
  background: lightblue;
}
.col {
  margin: 2px;
  height: 100px;
  color: grey;
  cursor: pointer;
}
.col:hover {
  color: black;
  height: 99px;
  border: 2px solid #563d7c;
  border-radius: 5px;
}
.mat-mdc-tooltip {
  color: yellow !important;
}
a {
  margin: 5px;
  color: black;
}
.active {
  background: #8468ac;
}
.header h4 p {
  position: relative;
  top: 18px;
  left: 10px;
}
.belowThreashold {
  background: #FF9494;
}
.framentLoaded {
  background: white;
  animation: color-me-in 5s;
}
.modified-row {
  background-color: #ecf2ff !important;
}
.modified-row td {
  font-weight: 600;
  color: #2a3547 !important;
}
@media screen and (max-width: 768px) {
  .mat-mdc-table .mat-mdc-row {
    height: 44px !important;
  }
  .mat-mdc-cell {
    font-size: 13px;
    color: #2a3547;
    padding: 0 4px !important;
  }
  app-action-button-toolbar mat-icon {
    font-size: 28px !important;
    width: 28px !important;
    height: 28px !important;
    margin: 0 2px;
    color: #5d87ff;
  }
  .row-action-buttons-cell {
    padding-right: 15px !important;
  }
  .mobile-fab-container {
    position: fixed;
    bottom: 25px;
    right: 20px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 15px;
  }
  .fab-button {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(93, 135, 255, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
  }
  .fab-save {
    background-color: #5d87ff;
    color: white;
  }
  .fab-save[disabled] {
    background-color: #dfe5ef;
    color: #7c8fac;
  }
}
@keyframes color-me-in {
  0% {
    background: var(--custom-color);
  }
  100% {
    background: white;
  }
}
/*# sourceMappingURL=stockcontroll.component.css.map */
